import { colors, screen } from 'components/styles/variables';
import manufacturerLogosSprite from 'public/static/images/oem-logos-sprite.png';
import logoSpritePositions from 'components/styles/logoSpritePositions';
import { ListItem } from 'types/TextSearch';
import images from 'public/static/images/text_search';

interface DropdownItemProps {
  item: ListItem;
  active: boolean;
  triggerSearch: (item: ListItem) => void;
}

export default function DropdownItem({
  item,
  active,
  triggerSearch,
}: DropdownItemProps): JSX.Element {
  const { iconClass, displayName } = item;
  return (
    <li
      className={active ? 'active text-search-dropdown-item' : 'text-search-dropdown-item'}
      onClick={(): void => triggerSearch(item)}
    >
      <div className="logo-container">
        <div className={`logo logo--${iconClass}`} />
      </div>
      <div>{displayName}</div>
      <style jsx>{`
        .text-search-dropdown-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          overflow: hidden;
          border-bottom: none;
          padding: 9px 0 9px 16px;
        }

        .text-search-dropdown-item:focus {
          background-color: ${colors.G1};
        }

        .link {
          display: flex;
          align-items: center;
        }

        @media (min-width: ${screen.smMin}) {
          .text-search-dropdown-item {
            padding: 5px 10px;
          }

          li:hover,
          .active {
            background-color: ${colors.G1};
          }
        }

        .logo-container {
          width: 48px;
          height: 48px;
        }

        .logo {
          background-image: url('${manufacturerLogosSprite}');
          background-repeat: no-repeat;
          background-size: 80%;
          height: 60px;
          width: 60px;
        }

        .logo--convertible {
          background: url(${images.convertible});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--coupe {
          background: url(${images.coupe});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--crossover {
          background: url(${images.crossover});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--hatchback {
          background: url(${images.hatchback});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--hybrid {
          background: url(${images.hybrid});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--minivan {
          background: url(${images.minivan});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--sedan {
          background: url(${images.sedan});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--small {
          background: url(${images.small});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--sport {
          background: url(${images.sport});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--suv {
          background: url(${images.suv});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--truck {
          background: url(${images.truck});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
        .logo--wagon {
          background: url(${images.wagon});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: -2px 10px;
          width: 48px;
        }
      `}</style>
      <style jsx>{logoSpritePositions}</style>
    </li>
  );
}
